<template>
  <div class="notfound-container">
    <div style="text-align: center;width: 80%;">
      <Icon type="iconzanwu" class="iconZanwu"></Icon>
      <div class="zanwuContent">未找到相关界面</div>
      <button class="button-bottom" @click="backToHome">回到首页</button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    backToHome() {
      this.$router.push("/");
    }
  }
};
</script>
<style lang="less" scoped>
.notfound-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .iconZanwu {
    font-size: 200px;
    margin-bottom: 16px;
  }
  .zanwuContent {
    text-align: center;
    color: #ababab;
    font-size: 14px;
    margin-bottom: 16px;
  }
}
.button-bottom {
  height: 80px;
  width: 100%;
}
</style>
